/**
 * @see https://stackoverflow.com/a/7616484
 *
 * @param {string} string
 * @return{string}
 */
export function hashCode(string: string): string {
    if (string.length === 0) {
        return '0';
    }

    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = ((hash << 5) - hash) + string.charCodeAt(i);
        hash = hash & hash; // convert to 32bit integer
    }

    hash = hash >>> 0; // convert signed to unsigned https://stackoverflow.com/a/1908655

    return Number(hash).toString(32); // convert base10 to base32
}
